/**
 * Shared help-tooltip copy for the "Revenue" figure (`Highlights.total_payout`).
 *
 * The SAME number is surfaced in two places — the Show Dashboard "Revenue"
 * highlight tile and the Analytics "Revenue" KPI tile — so it must be described
 * identically. Both import this constant; do not inline a second copy.
 *
 * Wording is context-neutral (no "below"/page-specific anchors) so it reads
 * correctly on the dashboard and on the analytics page alike.
 */
export const REVENUE_HELP_COPY = {
	mainText:
		'Your net payout for this show: ticket sales plus any add-ons and custom fees, net of refunds, minus amounts already paid out to you. This is the bottom-line figure, so it can differ from the per-tier ticket-sales and price-estimate figures in Analytics.',
	codeText: 'revenue = ticket sales (price − discount + custom fees) + add-ons − refunds − payouts already sent to you',
	secondaryText: 'For the line-by-line ledger, see Transactions.',
} as const;
